module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/instagram/sola_sns_06-969b7ad7453512e2c6341ebd0066fe0c.jpg";